import React from 'react';

const EnvironmentRibbon = () => {
  const urlBase = window["runConfig"]?.URL_BASE;

  if (!urlBase) {
    return null;
  }

  if (urlBase.includes('qa-sigsa')) {
    return (
      <div className="env-ribbon env-ribbon-qa">
        <span className="env-ribbon-text">QA</span>
      </div>
    );
  }

  if (urlBase.includes('dev-sigsa')) {
    return <span className="env-ribbon env-ribbon-dev" aria-hidden="true" />;
  }

  return null;
};

export default EnvironmentRibbon;
